import { getUrlParameter, randomInt } from '@/utilities';

// Create a script element so we can inject the NetEnt gameinclusion script
var gameScript = document.createElement('script');

gameScript.setAttribute('type', 'text/javascript');
gameScript.setAttribute('language', 'javascript');
gameScript.setAttribute('src', `https://www.netent.com/en/wp-content/themes/netent_corp/assets/scripts/gameinclusion.js`);

// Append script
document.body.appendChild(gameScript);

gameScript.addEventListener('load', (e) => {
  startGame({ sessionId: `DEMO-${ randomInt(0,99999) }` }, getUrlParameter('key'));
});

gameScript.addEventListener('error', (e) => {
  window.parent.postMessage({ emitter: 'gameplay', success: false, error: { code: 400 } }, window.location.origin);
});

function startGame (session, gameKey) {
  // Game inclusion library root. Setting this ensures scripts all use the same root
  // (Fixes IE11 bug where it was setting the root to our server instead of NetEnt's)
  giLibRoot = 'https://www.netent.com/en/wp-content/themes/netent_corp/assets/scripts/';

  var config = {
    staticServer: 'https://netent-static.casinomodule.com/',
    gameServer: 'https://netent-game.casinomodule.com/',
    gameName: gameKey,
    sessionId: session.sessionId,
    targetElement: 'game',
    flashParams: {
      bgcolor: '000000'
    },
    mobileParams: {
      lobbyURL: window.location.origin + window.location.pathname
    }
  };

  if ( (config.gameId == "cosmicfortune") || (config.gameId == "neonstaxx_not_mobile") || (config.gameId == "blackjack3_not_mobile") ) {
    config.gameServer = "https://netentvgs-game-test.casinomodule.com/"
  }

  function success (netEntExtend) {
    var game = document.getElementById('game');

    game.style.width = '100%';
    game.style.height = '100%';

    window.parent.postMessage({ emitter: 'gameplay', success: true }, window.location.origin);
  };

  function error (e) {
    window.parent.postMessage({ emitter: 'gameplay', success: false, error: e }, window.location.origin);
  };

  netent.launch(config, success, error);
};


// WEBPACK FOOTER //
// ./resources/assets/js/app/gameplay/netent.js